var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.611,
    height: 11.496,
    viewBox: "0 0 10.611 11.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-6532631",
    transform: "translate(-16 -56.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10",
    transform: "translate(12 53.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9665",
    "data-name": "Path 9665",
    d: "M4,5.211a.442.442,0,0,0,.442.442h.026c0,.015,0,.029,0,.044l.387,7.749a1.1,1.1,0,0,0,1.1,1.05h6.7a1.1,1.1,0,0,0,1.1-1.05L14.145,5.7c0-.015,0-.029,0-.044h.026a.442.442,0,1,0,0-.884H11.862l-.275-1.1A.883.883,0,0,0,10.729,3H7.882a.883.883,0,0,0-.858.67l-.275,1.1H4.442A.442.442,0,0,0,4,5.211ZM7.882,3.884h2.847l.221.884H7.661ZM7.095,5.653h6.167L12.875,13.4a.221.221,0,0,1-.221.21h-6.7a.221.221,0,0,1-.221-.21L5.348,5.653Z",
    transform: "translate(0 0)",
    fill: "#c8102f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9666",
    "data-name": "Path 9666",
    d: "M11.442,17.421a.442.442,0,0,0,.442-.442V13.442a.442.442,0,0,0-.884,0v3.537A.442.442,0,0,0,11.442,17.421Z",
    transform: "translate(-3.905 -5.579)",
    fill: "#c8102f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9667",
    "data-name": "Path 9667",
    d: "M19.442,17.421a.442.442,0,0,0,.442-.442V13.442a.442.442,0,1,0-.884,0v3.537A.442.442,0,0,0,19.442,17.421Z",
    transform: "translate(-8.368 -5.579)",
    fill: "#c8102f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9668",
    "data-name": "Path 9668",
    d: "M15.442,17.421a.442.442,0,0,0,.442-.442V13.442a.442.442,0,1,0-.884,0v3.537A.442.442,0,0,0,15.442,17.421Z",
    transform: "translate(-6.136 -5.579)",
    fill: "#c8102f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconRed);
export default __webpack_public_path__ + "static/media/delete-icon-red.2de66df66dd09d89cc74fefcb0384d04.svg";
export { ForwardRef as ReactComponent };